import { getCookie } from 'cookies-next';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface DeviceInfo {
  isMobile: boolean;
  isWebView: boolean;
  currentDevice?: string | null;
}

interface MobileState extends DeviceInfo {
  setDeviceInfo: (deviceInfo: DeviceInfo) => void;
  checkDevice: () => void;
}

const useMobileStore = create<MobileState>()(
  devtools(
    (set) => ({
      isMobile: false,
      isWebView: false,
      currentDevice: null,
      setDeviceInfo: (deviceInfo: DeviceInfo) => set(deviceInfo, false, 'setDeviceInfo'),
      checkDevice: () => {
        const mobileRegex = /iPhone|iPad|iPod|Android/i;
        const isMobileDevice = mobileRegex.test(navigator.userAgent);

        const UA = navigator.userAgent.toLowerCase(); //userAgent 체크
        let currentDevice = 'other';
        if (UA.indexOf('android') > -1) {
          currentDevice = 'android';
        } else if (
          UA.indexOf('iphone') > -1 ||
          UA.indexOf('ipad') > -1 ||
          UA.indexOf('ipod') > -1
        ) {
          //IOS
          currentDevice = 'ios';
        } else {
          currentDevice = 'other';
        }
        set(
          {
            isMobile: isMobileDevice,
            isWebView: getCookie('KEY_APP_ID') === process.env.NEXT_PUBLIC_APP_ID,
            currentDevice,
          },
          false,
          'checkDevice',
        );
      },
    }),
    {
      name: 'Mobile Store',
      enabled: true,
    },
  ),
);

export default useMobileStore;
